import { seededId, type BuildCtx, type Mutation } from '@tahi/core';

export const BUDGET_DASHBOARD_ID = 'budget';

export const BUDGET_DASHBOARD_TILES = [
  { type: 'budget.whats-left', size: 'wide' },
  { type: 'budget.safe-to-spend', size: 'small' },
  { type: 'budget.your-money', size: 'wide' },
] as const;

/** Budget dashboard tile rows not present locally; seeded ids, insert-if-absent (conventions §3). */
export function buildBudgetDashboardTiles(
  userId: string,
  existingTypes: ReadonlySet<string>,
  ctx: BuildCtx,
): Mutation[] {
  return BUDGET_DASHBOARD_TILES.flatMap((t, i): Mutation[] => {
    if (existingTypes.has(t.type)) return [];
    return [
      {
        id: ctx.newId(),
        table: 'tiles',
        op: 'insert',
        rowId: seededId(userId, 'tile', BUDGET_DASHBOARD_ID, t.type),
        values: {
          dashboardId: BUDGET_DASHBOARD_ID,
          moduleId: 'budget',
          type: t.type,
          position: i + 1,
          size: t.size,
          hidden: false,
          config: {},
        },
        at: ctx.now,
        source: 'budget',
        ifAbsent: true,
      },
    ];
  });
}
